import { InjectionToken } from '@angular/core';
import { NotificationDto } from '@bannerflow/types.notification-service';
import { Subject } from 'rxjs';

export const NS_CONFIG_TOKEN = new InjectionToken<NSNotificationModuleOptions>(
  'ns_config'
);

export interface NSNotificationModuleOptions {
  apiUri: string;
  accessToken$: Subject<string | undefined>;
  signalR: {
    enabled: boolean;
    url: string;
  };
}

export interface NotificationClickEvent {
  notification: NotificationDto;
  /** Synchronous only. Cancelling after the handler returns has no effect. */
  preventDefault(): void;
}
